import axios, { AxiosResponse } from 'axios'
import { AppDispatch } from '../store/store'
import { RegisterData } from '../models/AuthModel'
import {
  GET_LOGGED_USER_INFOS,
  LOGIN_URL,
  LOGOUT_URL,
  REGISTER_URL,
  FORGOT_PASSWORD_URL,
  RESET_PASSWORD_URL,
  GET_LOGGED_USER_ACCOUNTS,
  IDENTITY_VERIFICATION_GLEAP_URL,
} from './urls'
import { APIResponse } from '../models/helper'
import { User } from '../models/User'
import { Account } from '../models/Account'
import { resetUserState } from '../store/UserReducer'
import { resetProfileState } from '../store/ProfileReducer'
import { resetAutomationState } from '../store/AutomationReducer'
import { resetAnswerState } from '../store/AnswerReducer'
import { resetContactState } from '../store/ContactReducer'
import { resetAnalyticsEventState } from '../store/AnalyticsEventReducer'

/**
 * Reset Redux store to its initial state
 * Must be dispatched!
 */
const resetStore = () => (dispatch: AppDispatch) => {
  dispatch(resetProfileState())
  dispatch(resetAutomationState())
  dispatch(resetAnswerState())
  dispatch(resetContactState())
  dispatch(resetAnalyticsEventState())
  dispatch(resetUserState())
}

function login(email: string, password: string) {
  return axios.post(LOGIN_URL, null, {
    headers: { Authorization: 'Basic ' + btoa(`${email}:${password}`) },
  })
}

export function register(data: RegisterData) {
  return axios.post(REGISTER_URL, data)
}

export function logout() {
  return axios.post(LOGOUT_URL)
}

export function getLoggedUserInfos() {
  return axios.get<APIResponse<User>>(GET_LOGGED_USER_INFOS)
}

export function getLoggedUserAccounts() {
  return axios.get<APIResponse<Account[]>>(GET_LOGGED_USER_ACCOUNTS)
}

export function updateLoggedUserInfos(user: User) {
  return axios.put(GET_LOGGED_USER_INFOS, user)
}

export function forgotPassword(email: string) {
  return axios.post(FORGOT_PASSWORD_URL, { email: email })
}

export function resetPassword(email: string, token: string, password: string) {
  return axios.post(RESET_PASSWORD_URL, {
    email: email,
    token: token,
    password: password,
    password_confirmation: password,
  })
}

export function identityVerificationGleap(): Promise<
  AxiosResponse<APIResponse<{ hash: string }>>
> {
  return axios.get(IDENTITY_VERIFICATION_GLEAP_URL)
}

export { resetStore, login }
